import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { costs, faqs } from '../data/offer';
import { purchases } from '../data/testimonials';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-20" data-mp="3bt44hxwhrzod">
        <div className="mx-auto max-w-3xl text-center" data-id="element-21" data-mp="3brj4vtvblqjn">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-22" data-mp="3gkceav1qhn22" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-23" data-mp="31vg6mz3lac1z">
            GARANTÍA 14 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-24" data-mp="36uj15ply0zvp">
            <p className="text-slate-300" data-id="element-25" data-mp="2svjcihyfkkzj">Abrís los volúmenes. Aplicás el método.</p>
            <p className="mt-4 text-slate-300" data-id="element-26" data-mp="2ww39nlj07olo">
              Si en 14 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-27" data-mp="2fpyx4zygi2cy">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-28" data-mp="2pqj0q99g7iyc">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-29" data-mp="2kr6632cc57l7">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>
      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-30" data-mp="1x1tvby1d0rgs">
        <div className="mx-auto max-w-3xl" data-id="element-31" data-mp="1s2r015b6lzm0">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-32" data-mp="1s426jcw0hlgt">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-33" data-mp="220ezg8jqfvai">
            {faqs.map(({
            question,
            answer
          }, index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-34" data-mp="1e8pyy4wrc0ih" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-35" data-mp="1yz3q2idgmcwt">
                    <span data-id="element-36" data-mp="1g1iyh3jb908i">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-37" data-mp="1g2lprckjp4oy" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-38" data-mp="1u1tpq7oj8gu7">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-39" data-mp="30hnpp6l4taf8">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-40" data-mp="k2snw5bufc7b">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-41" data-mp="13ogt23v3sia">
      <div className="mx-auto max-w-4xl" data-id="element-42" data-mp="146msqgbtl3e">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-43" data-mp="3sahh83qtznlr">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL KIT?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-44" data-mp="1vh672wvnj3h0">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-45" data-mp="1qh1p12f3i0oo">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-46" data-mp="23gkn35im4ll9">
                ×
              </span>
              {item}
            </p>)}
        </div>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-47" data-mp="wugpxiwsta8k">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-48" data-mp="10vsfxpjl3xha">
          🎯 KIT ACUERDOS DE CUIDADO™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-49" data-mp="d8ew6b9cinpk">
          Metodología práctica para cuidadoras argentinas que quieren llegar a acuerdos
          de cuidado.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-50" data-mp="m938n1j3cg0c">
          “Tus acuerdos no son solo palabras. Son la forma de cuidar el vínculo mientras
          cuidás.”
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-51" data-mp="w7annettknzp">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-52" data-mp="19yo2ifgs8xoe">
            📧 soportebiomalivido@gmail.com
          </a>
          <span data-id="element-53" data-mp="15ydme9za0qvt">📲 @biomalivido</span>
          <a className="hover:text-brand-light" href="https://biomalivido.com" target="_blank" rel="noreferrer" data-id="element-54" data-mp="15zge2k4faxcs">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-55" data-mp="ckw2q0kr05k8">
          © KIT ACUERDOS DE CUIDADO™ 2026 — Todos los derechos reservados.
        </p>
      </footer>
      <AnimatePresence data-id="element-56" data-mp="gjv6hhuqtwa3">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-57" data-mp="lksn3q03ui9h">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-58" data-mp="14bacbklqavq3">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="199k5xqrt1o9l" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-60" data-mp="364gg32s2ijjl">
              {purchases[purchase].name} de {purchases[purchase].place}
            </p>
            <p className="text-sm text-slate-300" data-id="element-61" data-mp="33i7afdsxvbih">compró el Kit Acuerdos de Cuidado™</p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-62" data-mp="2yrqvfp9gzhu0">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}